
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!assignments.create_assignment";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'assignments/CreateAssignment';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"control-group\">\n      <label class=\"control-label\" for=\"";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignment_type\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "assignment_type", "Type:", options) : helperMissing.call(depth0, "t", "assignment_type", "Type:", options)))
    + "\n      </label>\n      <div class=\"controls\">\n        <select type=\"text\" id=\"";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignment_type\" name=\"submission_types\">\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.defaultToolName), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          <option value=\"none\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "assignment", "Assignment", options) : helperMissing.call(depth0, "t", "assignment", "Assignment", options)))
    + "</option>\n          <option value=\"discussion_topic\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "discussion_type", "Discussion", options) : helperMissing.call(depth0, "t", "discussion_type", "Discussion", options)))
    + "</option>\n          <option value=\"online_quiz\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "quiz_type", "Quiz", options) : helperMissing.call(depth0, "t", "quiz_type", "Quiz", options)))
    + "</option>\n          <option value=\"external_tool\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "external_tool_type", "External Tool", options) : helperMissing.call(depth0, "t", "external_tool_type", "External Tool", options)))
    + "</option>\n          <option value=\"not_graded\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "not_graded_type", "Not Graded", options) : helperMissing.call(depth0, "t", "not_graded_type", "Not Graded", options)))
    + "</option>\n        </select>\n      </div>\n    </div>\n    ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n            <option value=\"default_external_tool\" data-default-tool=\"true\">";
  if (helper = helpers.defaultToolName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.defaultToolName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</option>\n          ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <h3 id=\"";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignment_name\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h3>\n          <input\n            type=\"hidden\"\n            name=\"name\"\n            value=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n            "
    + escapeExpression((helper = helpers.disabledIfIncludes || (depth0 && depth0.disabledIfIncludes),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.frozenAttributes), "title", options) : helperMissing.call(depth0, "disabledIfIncludes", (depth0 && depth0.frozenAttributes), "title", options)))
    + "/>\n        ";
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <input\n            id=\"";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignment_name\"\n            type=";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.master_course_restrictions)),stack1 == null || stack1 === false ? stack1 : stack1.content), {hash:{},inverse:self.program(9, program9, data),fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            name=\"name\"\n            value=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n            "
    + escapeExpression((helper = helpers.disabledIfIncludes || (depth0 && depth0.disabledIfIncludes),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.frozenAttributes), "title", options) : helperMissing.call(depth0, "disabledIfIncludes", (depth0 && depth0.frozenAttributes), "title", options)))
    + "/>\n        ";
  return buffer;
  }
function program7(depth0,data) {
  
  
  return "\"hidden\"";
  }

function program9(depth0,data) {
  
  
  return "\"text\"";
  }

function program11(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"control-group\">\n      <label class=\"control-label\" for=\"";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignment_due_at\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "assignment_due_at", "Due:", options) : helperMissing.call(depth0, "t", "assignment_due_at", "Due:", options)))
    + "\n      </label>\n      <div class=\"controls\">\n      ";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.program(22, program22, data),fn:self.program(12, program12, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.multipleDueDates), (depth0 && depth0.isOnlyVisibleToOverrides), (depth0 && depth0.nonBaseDates), options) : helperMissing.call(depth0, "ifAny", (depth0 && depth0.multipleDueDates), (depth0 && depth0.isOnlyVisibleToOverrides), (depth0 && depth0.nonBaseDates), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </div>\n    ";
  return buffer;
  }
function program12(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <span class=\"datetime_field multiple_due_dates\" title\n              data-tooltip-selector=\"#vdd_tooltip_";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n              aria-labelledby=\"vdd_tooltip_";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n            <input\n              id=\"";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignment_due_at\"\n              class=\"input-medium\"\n              type=\"text\"\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.multipleDueDates), {hash:{},inverse:self.program(15, program15, data),fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              disabled=\"disabled\" />\n        </span>\n\n        <div id=\"vdd_tooltip_";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" style=\"display:none;\">\n          <dl class=\"vdd_tooltip_content dl-horizontal\">\n            ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.allDates), {hash:{},inverse:self.noop,fn:self.program(17, program17, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </dl>\n        </div>\n\n      ";
  return buffer;
  }
function program13(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                value=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "multiple_due_dates", "Multiple due dates", options) : helperMissing.call(depth0, "t", "multiple_due_dates", "Multiple due dates", options)))
    + "\"\n              ";
  return buffer;
  }

function program15(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                value=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "differentiated_due_dates", "Differentiated due date", options) : helperMissing.call(depth0, "t", "differentiated_due_dates", "Differentiated due date", options)))
    + "\"\n              ";
  return buffer;
  }

function program17(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n              <div class=\"clearfix\">\n                <dt>";
  if (helper = helpers.dueFor) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.dueFor); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</dt>\n                <dd>";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.dueAt), {hash:{},inverse:self.program(20, program20, data),fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</dd>\n              </div>\n            ";
  return buffer;
  }
function program18(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += " "
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.dueAt), "short", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.dueAt), "short", options)))
    + " ";
  return buffer;
  }

function program20(depth0,data) {
  
  
  return " - ";
  }

function program22(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <div class=\"date_field_container ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.master_course_restrictions)),stack1 == null || stack1 === false ? stack1 : stack1.due_dates), {hash:{},inverse:self.noop,fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n          ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.master_course_restrictions)),stack1 == null || stack1 === false ? stack1 : stack1.due_dates), {hash:{},inverse:self.noop,fn:self.program(25, program25, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          <input\n            id=\"";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignment_due_at\"\n            class=\"datetime_field input-medium\"\n            type=\"text\"\n            name=\"due_at\"\n            value=\""
    + escapeExpression((helper = helpers.datetimeFormatted || (depth0 && depth0.datetimeFormatted),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.dueAt), options) : helperMissing.call(depth0, "datetimeFormatted", (depth0 && depth0.dueAt), options)))
    + "\"\n            ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.master_course_restrictions)),stack1 == null || stack1 === false ? stack1 : stack1.due_dates), {hash:{},inverse:self.noop,fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            data-tooltip\n            "
    + escapeExpression((helper = helpers.disabledIf || (depth0 && depth0.disabledIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.disableDueAt), options) : helperMissing.call(depth0, "disabledIf", (depth0 && depth0.disableDueAt), options)))
    + "\n            ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.master_course_restrictions)),stack1 == null || stack1 === false ? stack1 : stack1.due_dates), {hash:{},inverse:self.noop,fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          />\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isInClosedPeriod), {hash:{},inverse:self.noop,fn:self.program(29, program29, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </div>\n      ";
  return buffer;
  }
function program23(depth0,data) {
  
  
  return "readonly";
  }

function program25(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <label class=\"screenreader-only\" id=\"due_at_label_";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "due_at_5e18eeac", "Due At:", options) : helperMissing.call(depth0, "t", "due_at_5e18eeac", "Due At:", options)))
    + "\n              ";
  if (helper = helpers.datepickerScreenreaderPrompt) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.datepickerScreenreaderPrompt); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n            </label>\n          ";
  return buffer;
  }

function program27(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n              aria-labelledby=\"due_at_label_";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n              title=\"";
  if (helper = helpers.accessibleDateFormat) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.accessibleDateFormat); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n            ";
  return buffer;
  }

function program29(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <div>\n              <span>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "due_date_falls_in_a_closed_grading_period_e447ff2f", "Due date falls in a closed Grading Period", options) : helperMissing.call(depth0, "t", "due_date_falls_in_a_closed_grading_period_e447ff2f", "Due date falls in a closed Grading Period", options)))
    + "</span>\n            </div>\n            ";
  return buffer;
  }

function program31(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"control-group\">\n      <label class=\"control-label\" for=\"";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignment_points\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "assignment_points", "Points:", options) : helperMissing.call(depth0, "t", "assignment_points", "Points:", options)))
    + "\n      </label>\n      <div class=\"controls\">\n        <input\n          id=\"";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignment_points\"\n          class=\"input-small points_possible\"\n          type=\"text\"\n          name=\"points_possible\"\n          value=\""
    + escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.pointsPossible), options) : helperMissing.call(depth0, "n", (depth0 && depth0.pointsPossible), options)))
    + "\"\n          "
    + escapeExpression((helper = helpers.disabledIfIncludes || (depth0 && depth0.disabledIfIncludes),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.frozenAttributes), "points_possible", options) : helperMissing.call(depth0, "disabledIfIncludes", (depth0 && depth0.frozenAttributes), "points_possible", options)))
    + "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.master_course_restrictions)),stack1 == null || stack1 === false ? stack1 : stack1.points), {hash:{},inverse:self.noop,fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        />\n      </div>\n    </div>\n    ";
  return buffer;
  }

function program33(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <fieldset>\n        <div class=\"control-group\">\n          <label class=\"control-label\" id=\"post_to_sis_label\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'postToSISName': ((depth0 && depth0.postToSISName)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "sync_to_posttosisname_9837a8bf", "Sync to %{postToSISName}:", options) : helperMissing.call(depth0, "t", "sync_to_posttosisname_9837a8bf", "Sync to %{postToSISName}:", options)))
    + "\n          </label>\n          <label>\n            "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_post_to_sis"),
    'name': ("post_to_sis"),
    'aria-labelledby': ("post_to_sis_label"),
    'class': ("post_to_sis_checkbox")
  },data:data},helper ? helper.call(depth0, "postToSIS", options) : helperMissing.call(depth0, "checkbox", "postToSIS", options)))
    + "\n          </label>\n        </div>\n      </fieldset>\n    ";
  return buffer;
  }

function program35(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <button\n      class=\"btn btn-default save_and_publish\"\n      data-text-while-loading='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "saving", "Saving...", options) : helperMissing.call(depth0, "t", "saving", "Saving...", options)))
    + "'\n      type=\"button\"\n    >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "buttons.save_and_publish", "Save & Publish", options) : helperMissing.call(depth0, "t", "buttons.save_and_publish", "Save & Publish", options)))
    + "</button>\n  ";
  return buffer;
  }

  buffer += "<div class=\"form-dialog-content create_assignment_dialog\">\n  <div class=\"form-horizontal\">\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canChooseType), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    <div class=\"control-group\">\n      <label class=\"control-label\" for=\"";
  if (helper = helpers.uniqLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignment_name\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "assignment_name", "Name:", options) : helperMissing.call(depth0, "t", "assignment_name", "Name:", options)))
    + "\n      </label>\n      <div class=\"controls\">\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.master_course_restrictions)),stack1 == null || stack1 === false ? stack1 : stack1.content), {hash:{},inverse:self.program(6, program6, data),fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </div>\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hasDueDate), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hasPointsPossible), {hash:{},inverse:self.noop,fn:self.program(31, program31, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.postToSISEnabled), {hash:{},inverse:self.noop,fn:self.program(33, program33, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>\n<div class=\"form-controls\">\n  <button\n    class=\"more_options btn pull-left\"\n    type=\"button\"\n  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "more", "More Options", options) : helperMissing.call(depth0, "t", "more", "More Options", options)))
    + "</button>\n  <button\n    class=\"cancel_button btn dialog_closer\"\n    type=\"button\"\n  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "cancel", "Cancel", options) : helperMissing.call(depth0, "t", "cancel", "Cancel", options)))
    + "</button>\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(35, program35, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <button\n    class=\"create_assignment btn btn-primary\"\n    data-text-while-loading='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "saving", "Saving...", options) : helperMissing.call(depth0, "t", "saving", "Saving...", options)))
    + "'\n    type=\"submit\"\n  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.create_assignment")
  },data:data},helper ? helper.call(depth0, "save", "Save", options) : helperMissing.call(depth0, "t", "save", "Save", options)))
    + "</button>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  